import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const SEO = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  const supportedLngs = ["de", "en", "es", "fr", "it", "pt"];
  const baseUrl = "https://withlove.page";

  // Extract the language from pathname (if present)
  const pathParts = pathname.split("/");
  const potentialLang = pathParts[1]; // First part of the path (e.g., 'fr' in '/fr/create')

  // Check if the extracted part is a valid language
  const isLangInPath = supportedLngs.includes(potentialLang);

  // Remove the language prefix if it exists
  const cleanPathname = isLangInPath ? `/${pathParts.slice(2).join("/")}` : pathname;

  // Determine the current language (from URL or i18n fallback)
  const currentLang = isLangInPath ? potentialLang : i18n.language || "en";

  return (
    <Helmet prioritizeSeoTags>
      <html lang={currentLang} />
      <title>{t("meta.title")}</title>
      <meta name="description" content={t("meta.description")} />

      {/* OpenGraph & Twitter */}
      <meta property="og:title" content={t("meta.title")} />
      <meta property="og:description" content={t("meta.description")} />
      <meta property="og:url" content={`${baseUrl}/${currentLang}${cleanPathname}`} />

      {/* Hreflang Tags */}
      {supportedLngs.map((lang) => (
        <link
          key={lang}
          rel="alternate"
          href={`${baseUrl}/${lang}${cleanPathname}`}
          hrefLang={lang}
        />
      ))}
    </Helmet>
  );
};

export default SEO;
